import { useTranslation } from "react-i18next";
import SectionPage from "../SectionPage/SectionPage";


import cashdesk from "../../assets/module/1mdpi02.jpg";
import delivery from "../../assets/module/3mad6tn27fo.jpg";
import storehouse5 from "../../assets/module/1mdpi04.jpg";
import foodfactory from "../../assets/module/1mdpi05.jpg";
import manager from "../../assets/module/1mdpi01.jpg";
import waiter from "../../assets/module/1mdpi06.jpg";


import styles from "./ModuleSection.module.css";

const ModuleSection = () => {
  const { t } = useTranslation();

  /* ----------------------------------
   * Features Data (localized)
   * ---------------------------------- */
  const features = [
    {
      id: "cashdesk",
      image: cashdesk,
    },
    {
      id: "delivery",
      image: delivery,
    },
    {
      id: "storehouse5",
      image: storehouse5,
    },
    {
      id: "foodfactory",
      image: foodfactory,
    },
	{
      id: "manager",
      image: manager,
    },
    {
      id: "waiter",
      image: waiter,
    },
  ];

  return (
    <SectionPage
      id="module"
      title={t("module.title")}
      description={t("module.description")}
	  contentTitle={t("module.contentTitle")}

    >
      {features.map((feature, index) => {
	  const isReverse = index % 2 !== 0;
	  const list = t(`features.${feature.id}.list`, { returnObjects: true });

	  return (
		<div
		  key={feature.id}
		  className={`${styles.featureItem} ${isReverse ? styles.reverse : ""}`}
		>
		  {/* IMAGE */}
		  <div className={styles.imageWrapper}>
			<img
			  src={feature.image}
			  alt={t(`features.${feature.id}.title`)}
			  className={styles.image}
			/>
		  </div>

		  {/* CONTENT */}
		  <div className={styles.contentWrapper}>
			<h3 className={styles.featureTitle}>
			  {t(`features.${feature.id}.title`)}
			</h3>

			<div className={styles.subtitle}>
			  <span className={styles.logo}>
				r<span>_</span>k
			  </span>
			  <span className={styles.product}>
				{t(`features.${feature.id}.product`)}
			  </span>
			</div>

			<p className={styles.note}>
			  {t(`features.${feature.id}.note`)}
			</p>

			<ul className={styles.list}>
			  {Array.isArray(list) &&
				list.map(item => <li key={item}>{item}</li>)}
			</ul>
		  </div>
		</div>
	  );
	})}

    </SectionPage>
  );
};

export default ModuleSection;
